import { forwardRef } from 'react';

import ZuiCard from '@zenbusiness/zui/Card';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

const CardRoot = superstyled({
  name: 'CheckoutCard',
  slot: 'Root',
  tag: ZuiCard,
  propsAdded: {
    component: 'section',
    variant: 'elevation'
  },
  styles: ({ theme }) => ({
    borderRadius: theme.shape.rounded.xl,

    [theme.breakpoints.up('md')]: {
      borderRadius: theme.shape.rounded['2xl']
    }
  })
});

const Card = forwardRef(({ children, ...delegated }, forwardedRef) => {
  return (
    <CardRoot {...delegated} ref={forwardedRef}>
      <Stack spacing={2.5} sx={{ padding: { xs: 2, md: 3 } }}>
        {children}
      </Stack>
    </CardRoot>
  );
});
export default Card;
